module.exports = __webpack_public_path__ + "media/images/flags/NG-b9c783fed18dbd7ca7a1739c94caddb8.svg";